/**
 * Words of the conflict banner / 409 toast (T14-08) — 5 languages, plain words (design/04 §0).
 */
import { realtimeLocale } from "../i18n";

export interface ConflictLabels {
  /** Someone else changed what you are editing. */
  conflict: string;
  /** Same with a name: `{name}` is replaced. */
  conflictBy: string;
  /** Button of the banner. */
  reload: string;
  /** Toast after a save refused with 409 `version_conflict`. */
  savedByOther: string;
}

export const CONFLICT_LABELS = {
  en: {
    conflict: "Someone else changed this while you were editing.",
    conflictBy: "{name} changed this while you were editing.",
    reload: "Load latest",
    savedByOther: "Not saved — someone else saved first. The latest data is shown.",
  },
  ja: {
    conflict: "編集中に他の人がこの内容を変更しました。",
    conflictBy: "編集中に{name}さんがこの内容を変更しました。",
    reload: "最新を読み込む",
    savedByOther: "保存できませんでした。先に他の人が保存しました。最新の内容を表示しています。",
  },
  th: {
    conflict: "ข้อมูลนี้ถูกแก้โดยผู้อื่นระหว่างที่คุณแก้อยู่",
    conflictBy: "ข้อมูลนี้ถูกแก้โดย {name} ระหว่างที่คุณแก้อยู่",
    reload: "โหลดล่าสุด",
    savedByOther: "ยังไม่ได้บันทึก — มีคนอื่นบันทึกก่อน กำลังแสดงข้อมูลล่าสุด",
  },
  "zh-Hant": {
    conflict: "您編輯期間，其他人已修改此內容。",
    conflictBy: "您編輯期間，{name} 已修改此內容。",
    reload: "載入最新",
    savedByOther: "未儲存 — 其他人已先儲存。現在顯示最新內容。",
  },
  "zh-Hans": {
    conflict: "您编辑期间，其他人已修改此内容。",
    conflictBy: "您编辑期间，{name} 已修改此内容。",
    reload: "加载最新",
    savedByOther: "未保存 — 其他人已先保存。现在显示最新内容。",
  },
} satisfies Record<string, ConflictLabels>;

export function conflictLabels(
  locale: string | null | undefined,
  overrides?: Partial<ConflictLabels>,
): ConflictLabels {
  return { ...CONFLICT_LABELS[realtimeLocale(locale)], ...overrides };
}
